import React from 'react';
import { BarChart3, CalendarDays, Check, Info, Users } from 'lucide-react';
import { PulseRing } from './PulseRing';

const Change = ({ value, label }) => {
  if (value === null || value === undefined) return <div className="text-[17px] text-[#6b6270] leading-tight whitespace-nowrap">No prior data<br />{label}</div>;
  const up = value > 0;
  const color = up ? '#22B04B' : value < 0 ? '#EF3A5D' : '#EF3A5D';
  return (
    <div className="leading-tight">
      <div className="text-[23px] font-bold flex items-center gap-1.5 whitespace-nowrap" style={{ color: value === 0 ? '#2b2430' : '#2b2430' }}>
        <span style={{ color }}>{up ? '▲' : value < 0 ? '▼' : '◆'}</span>{up ? '+' : ''}{value}%
      </div>
      <div className="text-[17px] text-[#4a4250] whitespace-nowrap">{label}</div>
    </div>
  );
};

const Card = ({ bg, border, testid, children }) => (
  <div className="rounded-2xl flex items-center gap-4 px-6 min-w-0 overflow-hidden pulse-fade-in" style={{ background: bg, border: `1.5px solid ${border}` }} data-testid={testid}>{children}</div>
);

const Title = ({ children }) => <div className="text-[22px] font-bold text-[#2b2430] whitespace-nowrap">{children}</div>;
const Big = ({ children, testid }) => <div className="text-[60px] font-extrabold leading-none whitespace-nowrap text-[#1f1a24]" data-testid={testid}>{children}</div>;

export const PulseKpis = ({ k }) => (
  <div className="grid grid-cols-4 gap-5 h-[148px]">
    <Card bg="#f5eefa" border="#e2d2ef" testid="pulse-kpi-snap-cases">
      <Users size={62} color="#7a2a9c" fill="#7a2a9c" />
      <div className="flex-1 min-w-0"><Title>Active SNAP E&amp;T Cases</Title>
        <div className="flex items-end gap-5 mt-1"><Big testid="pulse-kpi-snap-cases-value">{k.active_snap_et_cases}</Big><Change value={k.active_snap_et_cases_change_30d} label="vs. last 30 days" /></div></div>
    </Card>
    <Card bg="#eef9fb" border="#c9edf3" testid="pulse-kpi-active-staff">
      <BarChart3 size={56} color="#19B5C9" strokeWidth={2.6} />
      <div className="flex-1 min-w-0"><Title>Active Staff Today</Title>
        <Big testid="pulse-kpi-active-staff-value"><span className="text-[54px]">{k.active_staff_today} <span className="text-[30px] font-bold">of</span> {k.total_staff}</span></Big>
        <div className="text-[15px] leading-tight text-[#4a4250] mt-1 flex items-center gap-1">Staff with at least one system activity today <Info size={15} className="shrink-0" /></div></div>
      <PulseRing percent={k.active_staff_percent} size={96} stroke={11} color="#19B5C9" track="#d6f1f5" testid="pulse-kpi-active-staff-ring">
        <span className="text-[24px]">{k.active_staff_percent}%</span>
      </PulseRing>
    </Card>
    <Card bg="#fffaea" border="#f8e7b0" testid="pulse-kpi-tasks-completed">
      <div className="w-[72px] h-[72px] rounded-full bg-[#F5B400] flex items-center justify-center shrink-0"><Check size={46} color="#fff" strokeWidth={4} /></div>
      <div className="flex-1 min-w-0"><Title>Tasks Completed</Title>
        <div className="flex items-end gap-5 mt-1"><Big testid="pulse-kpi-tasks-completed-value">{k.tasks_completed_today}</Big><Change value={k.tasks_completed_change} label="vs. yesterday" /></div></div>
    </Card>
    <Card bg="#fff1f3" border="#fad3da" testid="pulse-kpi-appointments">
      <CalendarDays size={64} color="#EF3A5D" strokeWidth={2.2} />
      <div className="w-px self-stretch my-6 bg-[#f3c2cc]" />
      <div className="flex-1 min-w-0"><Title>Appointments Today</Title>
        <div className="flex items-end gap-5 mt-1"><Big testid="pulse-kpi-appointments-value">{k.appointments_today}</Big><Change value={k.appointments_change} label="vs. yesterday" /></div></div>
    </Card>
  </div>
);
